import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import PublishActivateDeactivateModal from '../../common/PublishActivateDeactivateModal';
import { convertUTCToLocal } from '../../utils/dateUtils';

const Categories = ({ persona }) => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [confirmActivateModal, setConfirmActivateModal] = useState({
    open: false,
    record: null,
  });
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
  });

  const navigate = useNavigate();

  //   const exportCSV = (selectionOnly) => {
  //     dt.current?.exportCSV({ selectionOnly });
  //   };
  //   const renderHeader = () => {
  //     return (
  //         <div className="flex justify-content-between">
  //             <PButton type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
  //             <IconField iconPosition="left">
  //                 <InputIcon className="pi pi-search" />
  //                 {/* <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" /> */}
  //                 <InputText type="search" value={globalFilter} onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search" />

  //             </IconField>
  //         </div>
  //     );
  // };

  // const handleSubComponentEvent = () => {
  //   console.log('Event triggered inside SubComponent!');
  // };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        // eslint-disable-next-line no-undef
        `${process.env.REACT_APP_SERVER_URL}/api/categories`,
        {
          withCredentials: true,
          params: paginationParams,
        }
      );

      // Handle response format: { data: [...], total: number }
      const categoriesData = response?.data?.data || response?.data || [];
      const total = response?.data?.total || categoriesData.length;

      const updatedData =
        categoriesData.map((item) => ({
          ...item,
          organizations_count: item.organizations?.length || 0,
          createdAt: convertUTCToLocal(item.createdAt),
        })) || [];

      setData(updatedData);
      setTotalRecords(total);
    } catch (error) {
      console.error('Error fetching roles:', error);
      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [persona, paginationParams]);

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
      page: event.page,
    }));
  };

  const columns = [
    { field: 'id', header: 'ID', sortable: true },
    { field: 'name', header: t('name'), sortable: true, filter: true },
    {
      field: 'organizations_count',
      header: t('No. of Organizations'),
    },
    {
      field: 'createdAt',
      header: t('createdAt'),
      sortable: true,
      filter: true,
    },
  ];

  const actions = [
    {
      text: t('organizations'),
      color: 'primary',
      onClick: (row) =>
        navigate(`/${persona}/categories/${row.id}/organizations`, {
          state: { category: row },
        }),
    },
    {
      text: t('edit'),
      color: 'secondary',
      onClick: (row) => navigate(`/${persona}/categories/edit/${row.id}`),
    },
    {
      text: 'Publish / Activate / Deactivate',
      color: 'primary',
      onClick: (row) => setConfirmActivateModal({ open: true, record: row }),
      status: 'success',
    },
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        actions={actions}
        loading={loading}
        totalRecords={totalRecords}
        enableCreate={true}
        enablePagination={true}
        enableLazyLoading={true}
        enableExport={true}
        paginationParams={paginationParams}
        onDataTableEvent={onDataTableEvent}
      />

      {confirmActivateModal.open && (
        <PublishActivateDeactivateModal
          sentData={confirmActivateModal.record}
          onEvent={setConfirmActivateModal}
          onConfirm={fetchCategories}
          apiPath="categories"
          axios={axiosInstance}
          columnName="name"
          dbAction="status"
          sectionName={'Categories'}
        />
      )}
    </div>
  );
};

export default Categories;
